<template>
  <div>
    <section v-if="loaded" class="video-show">
      <VideoShow
        ref="videoShowRef"
        v-bind="$attrs"
      />
    </section>
    <div v-else>
      <div class="spinner-wrapper">
        <i class="fa fa-spinner fa-spin fa-4x" />
      </div>
    </div>
  </div>
</template>

<script>
import axios from 'axios'
import { nextTick } from 'vue'
import VideoShow from './show/video-show.vue'
import { useProvideVideoShow } from './use-video-show'

export default {
  name: 'Show',
  components: {
    VideoShow,
  },
  inheritAttrs: false,
  props: {
    videoId: {
      default: null,
    },
    videoCanonical: {
      default: null,
    },
  },
  setup() {
    useProvideVideoShow()
  },
  data() {
    return {
      loaded: false,
      video: null,
      profile: null,
      playlist: null,
    }
  },
  computed: {
    hasVideoParam() {
      return this.videoId || this.videoCanonical
    },
  },
  mounted() {
    this.loadVideo()
  },
  methods: {
    loadVideo() {
      if (!this.hasVideoParam) {
        console.error('Either videoId or videoCanonical is required')
        return
      }

      const routeName = this.videoId ? 'api.video.show' : 'api.video.show-by-canonical'
      const routeParams = this.videoId
        ? { video: this.videoId }
        : { canonical: this.videoCanonical }

      axios.get(this.router(routeName, routeParams))
        .then((resp) => {
          this.profile = resp.data.profile
          this.video = resp.data.video
          this.playlist = resp.data.playlist
          this.loaded = true

          nextTick(() => {
            this.$refs.videoShowRef.assignData(this.video, this.profile, this.playlist)
          })
        })
    },
  },
}
</script>

<style scoped lang="scss">
.spinner-wrapper {
  position: absolute;
  left: 0;
  right: 0;
  top: 0;
  bottom: 0;
  display: flex;
  justify-content: center;
  align-items: center;
  flex-direction: column;
  background: #cfcfcf;
  opacity: 0.3;
}
</style>
